/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import {
  BigText,
  capitalizeFirstLetter,
  formatValidDate,
  PortalCard,
  SocialProvider,
} from "@advapacs/common";
import React, { FC } from "react";

export interface ISocialResponse {
  id?: string;
  type: SocialProvider;
  account: string;
  createdAt?: Date | string;
}

interface SocialItemProps {
  isMobile?: boolean;
  isMobileOnly?: boolean;
  item: ISocialResponse;
  dateTimeFormat?: string;
  onDisconnect: () => void;
}

export const SocialItem: FC<SocialItemProps> = ({
  isMobile = false,
  isMobileOnly = false,
  dateTimeFormat,
  item,
  onDisconnect,
}) => {
  return (
    <>
      <PortalCard
        isMobile={isMobile}
        isMobileOnly={isMobileOnly}
        wrapperClass="study-card m-t-md"
      >
        <div className="">
          <h5 className="font-weight">{capitalizeFirstLetter(item.type)}</h5>

          {isMobileOnly && (
            <>
              <div className="m-t-xs d-flex ">
                <span className="text-label-fixed account m-r-xs">Account</span>
                <BigText text={item.account} />
              </div>
              <div className="m-t-xs d-flex ">
                <span className="text-label-fixed account m-r-xs">
                  Connected At
                </span>
                <BigText
                  text={formatValidDate(item.createdAt, dateTimeFormat)}
                />
              </div>

              <button
                className="m-t-xs btn btn-light border-danger text-danger w-100 bg-white"
                onClick={() => {
                  onDisconnect();
                }}
              >
                Disconnect
              </button>
            </>
          )}

          {!isMobileOnly && (
            <div className="flexbox align-items-center w-100">
              <div className="m-t-xs  flex-1">
                <div className="m-t-xs d-flex ">
                  <span className="text-label-fixed account m-r-xs">
                    Account
                  </span>
                  <BigText text={item.account} />
                </div>
                <div className="flexbox">
                  <span className="m-r-xs text-label-fixed account">
                    Connected At
                  </span>
                  <BigText
                    maxWidth={"100%"}
                    text={formatValidDate(item.createdAt, dateTimeFormat)}
                  />
                </div>
              </div>
              <button
                className="m-t-xs btn btn-light border-danger text-danger w-100px bg-white"
                onClick={() => {
                  onDisconnect();
                }}
              >
                Disconnect
              </button>
            </div>
          )}
        </div>
      </PortalCard>
    </>
  );
};
